import { request } from '@/shared/api/request'

export const getLaborRecords = (payload) => {
	return request({ url: 'contract/labor/getLaborRecordsData', method: 'POST', data: payload })
}
